import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Grid, Header, Icon } from 'semantic-ui-react';
import { ApplicationState, strings } from '../..';
import { Matricola, TipoIntervento } from '../../core-assistenza';
import Riepilogo from './Riepilogo';
import SelezionaMatricola from './SelezionaMatricola';
import SelezionaRichiesta from './SelezionaRichiesta';
import StepAssistenza from './StepAssistenza';
import { Allegato } from '../../archiviazione/models';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../../application-insight/telemetryService';

const connector = connect(
    (state: ApplicationState) => ({ 
        anagrafica: state.core.anagrafiche.anagrafica!,
        hasArchiviazione: state.core.moduli.chiamateArchivi
    }),
)
type PropsFromRedux = ConnectedProps<typeof connector>

type HardwareProps = PropsFromRedux

type HardwareState = {
    actualStep: number,
    matricola?: Matricola,
    idTipoRichiesta: string,
    descrizioneAggiuntiva: string,
    allegati: Allegato[]
}

class Hardware extends React.Component<HardwareProps, HardwareState> {
    constructor(props: HardwareProps) {
        super(props);

        this.state = {
            actualStep: 0,
            matricola: undefined,
            idTipoRichiesta: '',
            descrizioneAggiuntiva: '',
            allegati: []
        };
    }

    render() {
        const { actualStep } = this.state;
        const { anagrafica } = this.props;

        return (
            <Grid stackable centered>
                <Grid.Row centered>
                    <Header as='h2'>
                        <Icon name='print' />
                        <Header.Content>
                            {strings.chiamate.hardware.titolo}
                            <Header.Subheader>{anagrafica.ragioneSociale}</Header.Subheader>
                        </Header.Content>
                    </Header>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign='center'>
                        <StepAssistenza stepAttuale={actualStep} firstStepDescription='Seleziona la macchina' onClick={this.onGoBack} />
                    </Grid.Column>
                </Grid.Row>
                {actualStep === 0 && this.renderSelezioneMatricola()}
                {actualStep === 1 && this.renderSelezionaRichiesta()}
                {actualStep === 2 && this.renderRiepilogo()}
            </Grid>
        );
    }

    renderSelezioneMatricola = () => {
        return (
            <Grid.Row>
                <Grid.Column>
                    <SelezionaMatricola
                        tipologia={TipoIntervento.Hardware}
                        onSelectMatricola={this.onSelectMatricola}
                    />
                </Grid.Column>
            </Grid.Row>
        );
    }

    renderSelezionaRichiesta = () =>{
        return (
            <SelezionaRichiesta
                matricola={this.state.matricola!}
                tipologia={TipoIntervento.Hardware}
                idTipoRichiesta={this.state.idTipoRichiesta}
                descrizioneAggiuntiva={this.state.descrizioneAggiuntiva}
                allegati={this.state.allegati}
                hasArchiviazione={this.props.hasArchiviazione}
                onDettagliInseriti={this.onDettagliInseriti}
                onGoBack={this.onGoBack}
                onImageAdded={this.onImageAdded}
                onImageRemoved={this.onImageRemoved}
            />
        );
    }

    onImageAdded = (image: Allegato) => {
        const newAllegati = Array.from(this.state.allegati);
        newAllegati.push(image);

        this.setState({
            ...this.state,
            allegati: newAllegati
        });
    }

    onImageRemoved = (image: Allegato) => {
        const newAllegati = Array.from(this.state.allegati);
        const index = newAllegati.indexOf(image);
        if (index > -1) {
            newAllegati.splice(index, 1);
            
            this.setState({
                ...this.state,
                allegati: newAllegati
            });
        }
    }

    renderRiepilogo = () => {
        const { matricola, idTipoRichiesta, descrizioneAggiuntiva, allegati } = this.state;
        return (
            <Riepilogo
                matricola={matricola!}
                tipologia={TipoIntervento.Hardware}
                idTipoRichiesta={idTipoRichiesta}
                descrizioneAggiuntiva={descrizioneAggiuntiva}
                hasArchiviazione={this.props.hasArchiviazione}
                allegati={allegati}
                onGoBack={this.onGoBack}
                onImageAdded={this.onImageAdded}
                onImageRemoved={this.onImageRemoved}
            />
        );
    }

    onSelectMatricola = (matricola: Matricola) => {
        this.setState({ actualStep: 1, matricola });
    }

    onDettagliInseriti = (idTipoRichiesta: string, descrizioneAggiuntiva: string) => {
        this.setState({ actualStep: 2, idTipoRichiesta, descrizioneAggiuntiva });
    }

    onGoBack = (toStep: number) => {
        const { actualStep } = this.state;

        if (actualStep <= toStep) return;

        if (toStep === 0) {
            //this.props.actions.selectMatricola(undefined);
            this.setState({ actualStep: 0 });
        }
        else if (toStep === 1) {
            this.setState({ actualStep: 1 });
        }
    }
}

export default connector(withAITracking(ai.reactPlugin, Hardware, "Hardware"));